import { NativeModules } from 'react-native';

type QualarooMobileSdkType = {
};

const { QualarooMobileSdk } = NativeModules;

export default QualarooMobileSdk as QualarooMobileSdkType;
